import axios from "axios";

export const getIpAddress = async () => {
  let ip = "";
  try {
    const res = await axios.get("https://api.ipify.org?format=json");
    ip = res.data.ip;
  } catch (err) {}
  return ip;
};

/**
 * Generates a consistent hash from an IP address using a simple hash algorithm
 * @param {string} ip - The IP address to hash (supports IPv4 and IPv6)
 * @returns {string} - A hexadecimal hash string
 */
export function hashIP(ip) {
  let hash = 0;
  
  // Convert IP string to a consistent hash value
  for (let i = 0; i < ip.length; i++) {
    const char = ip.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Convert to unsigned 32-bit integer and then to hex
  return (hash >>> 0).toString(16).padStart(8, '0');
}
